import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {AXIOS_BASE_URL} from '../../constants';

axios.defaults.baseURL = AXIOS_BASE_URL;

const setAuthHeader = token => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};
const clearAuthHeader = () => {
  axios.defaults.headers.common.Authorization = '';
};

export const register = createAsyncThunk(
  'auth/register',
  async (credentials, thunkAPI) => {
    try {
      const response = await axios.post('/api/auth/register', credentials);
      setAuthHeader(response.data.token);
      return response.data;
    } catch (error) {
      alert(error.response.data.message); 
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const logIn = createAsyncThunk(
  'auth/logIn',
  async (credentials, thunkAPI) => {
    try {
      const response = await axios.post('/api/auth/login', credentials);
      setAuthHeader(response.data.token);
      return response.data;
    } catch (error) {
      alert(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const recovery = createAsyncThunk(
  'auth/recovery',
  async (credentials, thunkAPI) => {
    try {
      await axios.post('/api/auth/recovery', credentials);
      return;
    } catch (error) {
      alert(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const reset = createAsyncThunk(
  'auth/reset',
  async (credentials, thunkAPI) => {
    try {
      const response = await axios.post('/api/auth/reset', credentials);
      setAuthHeader(response.data.token);
      return response.data;
    } catch (error) {
      alert(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const logOut = createAsyncThunk(
  'auth/logOut', 
  async (_, thunkAPI) => {
  try {
    await axios.post('/api/auth/logout');
    clearAuthHeader();
    return;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message);
  }
});

export const refreshUser = createAsyncThunk(
  'auth/refreshUser', 
  async (_, thunkAPI) => {
  const state = thunkAPI.getState();
  const persistedToken = state.auth.token;

  if (persistedToken === null) {
    return thunkAPI.rejectWithValue('Unable to fetch user');
  }
  try {
    setAuthHeader(persistedToken);
    const res = await axios.get('/api/auth/current');
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message);
  }
});